import { render, staticRenderFns } from "./singleNewsEvents.vue?vue&type=template&id=64d0ef8c&scoped=true&"
import script from "./singleNewsEvents.vue?vue&type=script&lang=js&"
export * from "./singleNewsEvents.vue?vue&type=script&lang=js&"
import style0 from "./singleNewsEvents.vue?vue&type=style&index=0&id=64d0ef8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d0ef8c",
  null
  
)

export default component.exports